import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialogModule} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";

@Component({
    selector: 'app-loading-dialog',
    imports: [MatDialogModule, MatIconModule],
    templateUrl: './loading-dialog.component.html',
    styleUrls: ['./loading-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LoadingDialogComponent {
}
